webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(125);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(124);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(101);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _routes = __webpack_require__(43);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _App = __webpack_require__(102);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _routes2.default,
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition;
	    }
	
	    return { x: 0, y: 0 };
	  }
	});
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueHead2.default, {
	  inner: 'Sound design and field recording',
	  separator: '-',
	  complement: 'Rick Blything'
	});
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(62)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(117),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(65)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(121),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Home = __webpack_require__(108);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Services = __webpack_require__(110);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _Blog = __webpack_require__(105);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	var _Commercials = __webpack_require__(106);
	
	var _Commercials2 = _interopRequireDefault(_Commercials);
	
	var _Post = __webpack_require__(109);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Work = __webpack_require__(111);
	
	var _Work2 = _interopRequireDefault(_Work);
	
	var _About = __webpack_require__(104);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Contact = __webpack_require__(107);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _ = __webpack_require__(103);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  component: _Home2.default
	}, {
	  path: '/services',
	  component: _Services2.default
	}, {
	  path: '/commercials',
	  component: _Commercials2.default
	}, {
	  path: '/blog',
	  component: _Blog2.default
	}, {
	  path: '/blog/:slug',
	  component: _Post2.default
	}, {
	  path: '/work/:slug',
	  component: _Work2.default
	}, {
	  path: '/about',
	  component: _About2.default
	}, {
	  path: '/contact',
	  component: _Contact2.default
	}, {
	  path: '/404',
	  component: _2.default
	}];

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app',
	
	  computed: {
	    getYear: function getYear() {
	      return new Date().getFullYear();
	    }
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'loader'
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'site-header',
	
	  computed: {
	    isHome: function isHome() {
	      return this.$route.path === '/';
	    }
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	
	  components: {
	    SiteHeader: _SiteHeader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'Page not found'
	      };
	    }
	  }
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _each = __webpack_require__(90);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'about',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'About'
	      };
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      page: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/pages/about').then(function (response) {
	      if (response.data) {
	        _this.loading = false;
	        _this.page = response.data[0];
	      }
	    });
	  },
	  updated: function updated() {
	    var _this2 = this;
	
	    var links = this.$refs.pageContent.querySelectorAll('a');
	
	    (0, _each2.default)(links, function (link) {
	      link.addEventListener('click', function (e) {
	        e.preventDefault();
	
	        _this2.$router.push(e.target.getAttribute('href'));
	      });
	    });
	  }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fecha = __webpack_require__(15);
	
	var _fecha2 = _interopRequireDefault(_fecha);
	
	var _lodash = __webpack_require__(23);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'blog',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      posts: []
	    };
	  },
	
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'Blog'
	      };
	    }
	  },
	
	  methods: {
	    getImage: function getImage(item) {
	      if (!(0, _lodash.get)(item, '_embedded[\'wp:featuredmedia\'][0].media_details.sizes')) {
	        return null;
	      }
	
	      var obj = item['_embedded']['wp:featuredmedia'][0].media_details.sizes;
	
	      if (typeof obj.large !== 'undefined') {
	        return obj.large.source_url;
	      }
	
	      if (typeof obj.medium_large !== 'undefined') {
	        return obj.medium_large.source_url;
	      }
	
	      if (typeof obj.medium !== 'undefined') {
	        return obj.medium.source_url;
	      }
	
	      if (typeof obj.full !== 'undefined') {
	        return obj.full.source_url;
	      }
	
	      return null;
	    },
	    formatDate: function formatDate(date) {
	      return _fecha2.default.format(new Date(date), 'DD.MM.YYYY');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/posts').then(function (response) {
	      _this.loading = false;
	      _this.posts = response.data;
	    }).catch(function () {
	      _this.$router.push('/404');
	    });
	  }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'commercials',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'Commercials'
	      };
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      brands: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/commercials').then(function (response) {
	      if (response.data) {
	        _this.loading = false;
	        _this.brands = response.data;
	      }
	    });
	  }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autosize = __webpack_require__(25);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'contact',
	
	  components: {
	    SiteHeader: _SiteHeader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'Get in contact'
	      };
	    }
	  },
	
	  mounted: function mounted() {
	    (0, _autosize2.default)(this.$refs.enquiry);
	  }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(23);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  head: {
	    title: {
	      inner: 'Sound design and field recording'
	    },
	    meta: [{
	      name: 'description',
	      content: 'Freelance sound designer & field recordist based in London. Specialising in sound design for documentaries, FX recording, feature films, games, radio and installations'
	    }]
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      items: []
	    };
	  },
	
	
	  methods: {
	    getImage: function getImage(item) {
	      if (!(0, _lodash.get)(item, '_embedded[\'wp:featuredmedia\'][0].media_details.sizes')) {
	        return null;
	      }
	
	      var obj = item['_embedded']['wp:featuredmedia'][0].media_details.sizes;
	
	      if (typeof obj.medium_large !== 'undefined') {
	        return obj.medium_large.source_url;
	      }
	
	      if (typeof obj.large !== 'undefined') {
	        return obj.large.source_url;
	      }
	
	      if (typeof obj.full !== 'undefined') {
	        return obj.full.source_url;
	      }
	
	      if (typeof obj.medium !== 'undefined') {
	        return obj.medium.source_url;
	      }
	
	      return null;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/work-items').then(function (response) {
	      if (response.data) {
	        _this.loading = false;
	        _this.items = response.data;
	      }
	    });
	  }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fecha = __webpack_require__(15);
	
	var _fecha2 = _interopRequireDefault(_fecha);
	
	var _he = __webpack_require__(16);
	
	var _he2 = _interopRequireDefault(_he);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'post',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      post: null
	    };
	  },
	
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.post ? _he2.default.decode(this.post.title.rendered) : 'Loading'
	      };
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/posts/' + this.$route.params.slug).then(function (response) {
	      if (response.data.length) {
	        _this.loading = false;
	        _this.post = response.data[0];
	        _this.$emit('updateHead');
	      } else {
	        _this.$router.push('/404');
	      }
	    }).catch(function () {
	      _this.$router.push('/404');
	    });
	  },
	
	
	  computed: {
	    postedAt: function postedAt() {
	      return _fecha2.default.format(new Date(this.post.date_gmt), '[Posted at] HH:MM [on] DD.MM.YYYY');
	    }
	  }
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'services',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: 'Services'
	      };
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      services: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/services').then(function (response) {
	      if (response.data) {
	        _this.loading = false;
	        _this.services = response.data;
	      }
	    });
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _he = __webpack_require__(16);
	
	var _he2 = _interopRequireDefault(_he);
	
	var _SiteHeader = __webpack_require__(3);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'work',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    Loader: _Loader2.default
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.item ? _he2.default.decode(this.item.title.rendered) : 'Loading'
	      };
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      item: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _axios2.default.get('/api/work-items/' + this.$route.params.slug).then(function (response) {
	      if (response.data.length) {
	        _this.loading = false;
	        _this.item = response.data[0];
	        _this.$emit('updateHead');
	      } else {
	        _this.$router.push('/404');
	      }
	    }).catch(function () {
	      _this.$router.push('/404');
	    });
	  },
	
	
	  computed: {
	    getVimeoUrl: function getVimeoUrl() {
	      var id = this.item.acf.vimeo_url.replace(/http(s)?:\/\/vimeo.com\//, '');
	
	      return 'https://player.vimeo.com/video/' + id;
	    }
	  }
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fourohfour":"_3wdiP35nOJ-bp7ziAB15NI_0"};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"_3R0FfcQmQrPANwgWOGbhXQ_0","intro":"_3pLCZucRakGLhytchJz2ri_0","form":"_1UNTdGa9Ib2LkNUUC-nAxB_0"};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blog":"_2uuqsk8NXtnzCRWX9Om3j_0","blogItems":"_1fRuwSwg-8-x3XKYITGW9K_0","thumbnail":"_3tKwXf7FGn4trV6f99KhiY_0","item":"xltssfnLQ0Xa5xKTkyRJA_0","meta":"_1nj6wpwqyDdjZ0SZzZje0z_0","title":"cAXATEMEdomUgNyuIo1ib_0","excerpt":"_2w0hWXgYlDWDFbiFaDUIc_0"};

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"work":"_1mXlwrruJa0J7rL4ooBSCj_0","workItems":"_3bEs8Fd1NkfizfXBAIS6f_0","item":"_2cB-B_jqsNE1eXEV6iPoEk_0","thumbnail":"_3KUeP8-28md6_s5DdJ7UCT_0","title":"_1A75HhoNvaP0OM-64X1I12_0","description":"_1_AUbpB9Xm_B9CsVnYdAT6_0"};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"commercials":"_25JmjQs-gj9oxgjVf6Sdns_0","lede":"_1apMvPggQK-HwsOy1oE65N_0","logos":"_1yxHGE0XZXMepXFw0V24Rz_0"};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"social":"_1Q7PmHHYGWUJRopsyGbFpi_0","imdb":"OrGIu5RJrseuw_q7Jk28a_0","twitter":"ufnEZYDxFq59nM5z3I0iS_0","soundcloud":"_2LcZff0yYc1kc2ajMwYCIb_0","linkedin":"_38y3DluqWX6CSpIPmYQjgQ_0","wrap":"LHfY_NzASt4MJqDDEk2sy_0","heading":"qaEb7I2qhUhLyn1bSNMkn_0","title":"_1xMhG5mbIg2Rcy947J0JQE_0","intro":"_3hkxYLSmSP4afnp-Kh15ba_0","nav":"_2u3ex9jXqw0IzTLTYbp9E7_0"};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post":"_1o-jY-vHJ7hiDiE_k2YlB7_0","header":"_37AZ-z933Rur9ihDYRDgVC_0","title":"kN8K61i5_rTIWbcTJ73Au_0","body":"_2mkRwUMKTgAaC6tgfb7FBn_0","meta":"_2WO1_CNLqda03HEoUCNnHZ_0","content":"pWi0GIr0Dw6vyPeZenw7O_0"};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"services":"XRY48fqsgTtnbYHj08cFB_0","item":"_2VB3teWQMBMmZ4YH4v8mM0_0","title":"_3IPGFZVs4rnPlQEeTtTuYw_0","description":"_1py81QRhnw12TqIdLHVy0e_0"};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"y7M4QNUAM6NkZg1__UtWL_0"};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post":"_2JR2p0LWUu59NqkvBI9ZwB_0","header":"_3WeFB6fhxHOKU97kZXlYXK_0","meta":"_1-sR7vekafNKlrEc3gdWyE_0","title":"cuLqMTM_NBEW_wNrIzOGS_0","body":"cO3adnejBovm91G82SrD9_0"};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"about":"_3hjzWDD7tUHsp5T2Q6ePt3_0","contactForm":"_1lFWgZWlo72d08BQZMUkow_0"};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"_31xbU_g0hq9YzSWczPjP3Q_1"};

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(56)
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(68)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(120),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(57)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(112),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(67)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(123),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(59)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(114),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(61)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(116),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(58)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(113),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(60)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(115),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(63)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(118),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(64)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(54),
	  /* template */
	  __webpack_require__(119),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	var cssModules = {}
	cssModules["$style"] = __webpack_require__(66)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(55),
	  /* template */
	  __webpack_require__(122),
	  /* scopeId */
	  null,
	  /* cssModules */
	  cssModules
	)
	
	module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.fourohfour
	  }, [_c('h1', [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("Something seems to have gone wrong.")]), _vm._v(" "), _c('p', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("← Back to the homepage")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Get in contact")])]), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.contact
	  }, [_c('p', {
	    class: _vm.$style.intro
	  }, [_vm._v("Please do not hesitate to get in touch with me using the form below or "), _c('a', {
	    attrs: {
	      "href": "mailto:r.blything@gmail.com?subject=Work%20enquiry"
	    }
	  }, [_vm._v("sending an email")]), _vm._v(" to discuss your design ideas; pre-production sound needs; sound effects available from my library, specific field sound requirements or any sound editing projects, I’ll be pleased to get involved.")]), _vm._v(" "), _c('form', {
	    class: _vm.$style.form,
	    attrs: {
	      "action": "https://formspree.io/r.blything@gmail.com",
	      "method": "POST"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', [_c('span', [_vm._v("How can I help you?")]), _vm._v(" "), _c('textarea', {
	    ref: "enquiry",
	    attrs: {
	      "name": "enquiry",
	      "rows": "1",
	      "required": ""
	    }
	  })]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "_subject",
	      "value": "Contact enquiry from rickblything.net"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "_next",
	      "value": "/about"
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', [_vm._v("Name")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "text",
	      "name": "_gotcha"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "text",
	      "name": "name"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', [_vm._v("Email address (required)")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "required": ""
	    }
	  })])
	}]}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Blog")])]), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.blog
	  }, [_c('div', {
	    class: _vm.$style.blogItems
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('article', {
	      class: _vm.$style.item
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/blog/" + (post.slug))
	      }
	    }, [(_vm.getImage(post)) ? _c('div', {
	      class: _vm.$style.thumbnail
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.getImage(post)
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('p', {
	      class: _vm.$style.meta
	    }, [_vm._v(_vm._s(_vm.formatDate(post.date_gmt)))]), _vm._v(" "), _c('h2', {
	      class: _vm.$style.title
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(post.title.rendered)
	      }
	    })])])], 1)
	  }), 0)]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.work
	  }, [_c('div', {
	    class: _vm.$style.workItems
	  }, _vm._l((_vm.items), function(item) {
	    return _c('article', {
	      class: _vm.$style.item
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/work/" + (item.slug))
	      }
	    }, [(_vm.getImage(item)) ? _c('div', {
	      class: _vm.$style.thumbnail
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.getImage(item)
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('h2', {
	      class: _vm.$style.title,
	      domProps: {
	        "innerHTML": _vm._s(item.title.rendered)
	      }
	    }), _vm._v(" "), _c('p', {
	      class: _vm.$style.description,
	      domProps: {
	        "innerHTML": _vm._s(item.acf.description)
	      }
	    })])], 1)
	  }), 0)]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Commercials")])]), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.commercials
	  }, [(!this.loading) ? _c('p', {
	    class: _vm.$style.lede
	  }, [_vm._v("I have carried out sound design duties on numerous commercials and promos. Some of the brands I've worked with are shown below.")]) : _vm._e(), _vm._v(" "), _c('article', {
	    class: _vm.$style.logos
	  }, _vm._l((_vm.brands), function(item) {
	    return _c('div', [_c('img', {
	      attrs: {
	        "src": item.acf.logo.sizes.large
	      }
	    })])
	  }), 0)]), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('nav', {
	    class: _vm.$style.social
	  }, [_c('div', {
	    staticClass: "wrap",
	    class: _vm.$style.wrap
	  }, [_c('a', {
	    class: _vm.$style.imdb,
	    attrs: {
	      "href": "http://www.imdb.com/name/nm5037653"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill-rule": "evenodd",
	      "stroke-miterlimit": "1.414",
	      "viewBox": "0 0 16 16",
	      "clip-rule": "evenodd",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M14.92 0H1.08C.495.04.04.496 0 1.064V14.92A1.14 1.14 0 0 0 1.067 16h13.896A1.151 1.151 0 0 0 16 14.86V1.14C16 .546 15.536.046 14.944 0h-.025zM1.925 5.507h1.27v4.91h-1.27v-4.91zm7.6 4.91c.302 0 .533-.02.682-.05a.818.818 0 0 0 .38-.177c.104-.08.176-.2.217-.348.04-.15.068-.443.068-.88V7.237c0-.465-.018-.778-.05-.935a.846.846 0 0 0-.208-.43c-.113-.13-.28-.22-.497-.28-.213-.054-.57-.086-1.18-.086h-.95v4.91h1.537zm3.426-1.19c0 .235-.013.385-.036.448-.022.063-.126.095-.203.095-.072 0-.127-.032-.15-.09-.027-.06-.04-.2-.04-.416V7.966c0-.222.013-.362.036-.416.022-.054.072-.08.144-.08.077 0 .18.026.207.094.03.063.042.2.042.402v1.26zM9.54 6.393c.05.027.08.072.094.136.02.062.023.207.023.428V8.86c0 .327-.023.526-.063.598-.04.077-.154.113-.335.113V6.348c.135 0 .23.014.28.046zM5.9 5.507l-.294 2.296-.18-1.247c-.055-.403-.105-.75-.154-1.05H3.626v4.91h1.112l.005-3.24.465 3.24H6l.447-3.314v3.314h1.108v-4.91H5.9zm5.402 0v4.91h1.144l.077-.313c.104.126.217.222.344.285.12.058.307.09.452.09.202 0 .374-.05.52-.16a.694.694 0 0 0 .278-.374 2.8 2.8 0 0 0 .06-.656V7.912c0-.294-.01-.488-.023-.58a.695.695 0 0 0-.113-.28.68.68 0 0 0-.285-.22 1.144 1.144 0 0 0-.438-.077c-.146 0-.332.03-.458.085-.122.06-.235.15-.34.267v-1.6H11.3z"
	    }
	  })])]), _vm._v(" "), _c('a', {
	    class: _vm.$style.twitter,
	    attrs: {
	      "href": "https://twitter.com/RickBlything"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill-rule": "evenodd",
	      "stroke-miterlimit": "1.414",
	      "viewBox": "0 0 16 16",
	      "clip-rule": "evenodd",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "nonzero",
	      "d": "M16 3.038a6.62 6.62 0 0 1-1.885.517 3.299 3.299 0 0 0 1.443-1.816 6.59 6.59 0 0 1-2.085.795 3.273 3.273 0 0 0-2.396-1.036 3.281 3.281 0 0 0-3.197 4.03A9.329 9.329 0 0 1 1.114 2.1 3.243 3.243 0 0 0 .67 3.75c0 1.14.58 2.143 1.46 2.732a3.278 3.278 0 0 1-1.487-.41v.04c0 1.59 1.13 2.918 2.633 3.22a3.336 3.336 0 0 1-1.482.056 3.287 3.287 0 0 0 3.067 2.28 6.592 6.592 0 0 1-4.077 1.404c-.265 0-.526-.015-.783-.045a9.303 9.303 0 0 0 5.032 1.474c6.038 0 9.34-5 9.34-9.338 0-.143-.004-.284-.01-.425a6.67 6.67 0 0 0 1.638-1.7z"
	    }
	  })])]), _vm._v(" "), _c('a', {
	    class: _vm.$style.soundcloud,
	    attrs: {
	      "href": "https://soundcloud.com/rickblything"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill-rule": "evenodd",
	      "stroke-miterlimit": "1.414",
	      "viewBox": "0 0 16 16",
	      "clip-rule": "evenodd",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "nonzero",
	      "d": "M.773 8.13c-.034 0-.062.03-.067.066L.55 9.633l.156 1.405c.005.038.033.065.067.065.033 0 .06-.027.066-.065l.178-1.405-.18-1.437C.835 8.158.807 8.13.774 8.13m-.594.552c-.032 0-.06.025-.063.062L0 9.634l.117.872c.004.037.03.063.064.063s.06-.027.065-.063l.14-.874-.14-.89c-.005-.036-.03-.06-.064-.06M1.4 7.85c-.04 0-.075.033-.08.078l-.148 1.705.15 1.643a.08.08 0 0 0 .08.078c.04 0 .074-.033.08-.078l.17-1.643-.17-1.705c-.006-.045-.04-.078-.08-.078m.633-.06c-.05 0-.09.04-.094.092l-.14 1.75.14 1.696c.005.052.045.092.095.092s.09-.04.094-.092l.16-1.695-.16-1.752c-.006-.05-.046-.09-.095-.09m.745 3.551zm0-3.334a.109.109 0 0 0-.106-.106c-.058 0-.104.046-.108.107l-.133 1.623.133 1.71c.004.06.05.105.108.105a.11.11 0 0 0 .107-.106l.152-1.71-.15-1.624zm.538-1.138a.122.122 0 0 0-.12.12L3.07 9.634l.125 1.71a.123.123 0 0 0 .12.118.125.125 0 0 0 .122-.12l.14-1.708-.14-2.644a.126.126 0 0 0-.122-.12m.642-.608a.137.137 0 0 0-.135.133l-.117 3.248.117 1.698a.137.137 0 0 0 .135.134c.072 0 .13-.058.135-.133v.002l.132-1.7-.132-3.247a.137.137 0 0 0-.135-.133m.663-.296a.15.15 0 0 0-.147.148l-.11 3.52.11 1.68a.15.15 0 0 0 .148.146c.08 0 .146-.065.15-.147l.123-1.68-.123-3.52a.153.153 0 0 0-.15-.147m.822.029a.163.163 0 0 0-.162-.16.16.16 0 0 0-.16.16l-.102 3.638.1 1.67a.163.163 0 0 0 .326 0l.113-1.67-.113-3.638zm0 5.307zm.502-5.389a.176.176 0 0 0-.175.175l-.093 3.545.093 1.654c.002.096.08.173.175.173a.177.177 0 0 0 .176-.175v.002l.105-1.655L6.12 6.09a.175.175 0 0 0-.175-.175m.67.115a.192.192 0 0 0-.19.19l-.084 3.416.086 1.643a.188.188 0 0 0 .19.186.191.191 0 0 0 .19-.188L6.9 9.635l-.095-3.416a.192.192 0 0 0-.19-.19m.787-.626a.211.211 0 0 0-.112-.034c-.04 0-.078.01-.11.032a.208.208 0 0 0-.093.17v.038L7.01 9.635l.077 1.634v.006a.206.206 0 0 0 .203.194.199.199 0 0 0 .142-.06.199.199 0 0 0 .06-.142l.01-.162.077-1.47-.087-4.065c0-.07-.037-.13-.09-.167m.091 5.867v-.002zm.579-6.252a.216.216 0 0 0-.327.185v.022l-.09 4.41.047.817.043.793a.22.22 0 0 0 .217.215.22.22 0 0 0 .217-.216v.002l.095-1.61-.096-4.433a.22.22 0 0 0-.108-.185m5.962 2.52c-.27 0-.527.055-.76.153a3.475 3.475 0 0 0-4.718-2.929c-.15.06-.188.117-.19.232v6.246c.002.12.095.215.213.226h5.455c1.087 0 1.968-.87 1.968-1.958 0-1.087-.88-1.968-1.968-1.968"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "wrap",
	    class: _vm.$style.heading
	  }, [(_vm.isHome) ? _c('h1', {
	    class: _vm.$style.title
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('b', [_vm._v("Rick Blything")]), _vm._v(" "), _c('span', [_vm._v("Sound design & field recording")])])], 1) : _c('p', {
	    class: _vm.$style.title
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('b', [_vm._v("Rick Blything")]), _vm._v(" "), _c('span', [_vm._v("Sound design & field recording")])])], 1), _vm._v(" "), _c('nav', {
	    class: _vm.$style.nav
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/about"
	    }
	  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/services"
	    }
	  }, [_vm._v("Services")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/commercials"
	    }
	  }, [_vm._v("Commercials")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/blog"
	    }
	  }, [_vm._v("Blog")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/contact"
	    }
	  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), (this.$slots.default) ? _c('div', {
	    staticClass: "wrap",
	    class: _vm.$style.intro
	  }, [_vm._t("default")], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', [(_vm.post) ? _c('article', {
	    staticClass: "wrap",
	    class: _vm.$style.post
	  }, [_c('header', {
	    class: _vm.$style.header
	  }, [_c('h1', {
	    class: _vm.$style.title,
	    domProps: {
	      "innerHTML": _vm._s(_vm.post.title.rendered)
	    }
	  })]), _vm._v(" "), _c('div', {
	    class: _vm.$style.body
	  }, [_c('div', {
	    class: _vm.$style.content,
	    domProps: {
	      "innerHTML": _vm._s(_vm.post.content.rendered)
	    }
	  }), _vm._v(" "), _c('p', {
	    class: _vm.$style.meta
	  }, [_vm._v(_vm._s(_vm.postedAt))])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Services")])]), _vm._v(" "), _c('main', {
	    staticClass: "wrap",
	    class: _vm.$style.services
	  }, _vm._l((_vm.services), function(item) {
	    return _c('article', {
	      class: _vm.$style.item
	    }, [_c('h2', {
	      class: _vm.$style.title,
	      domProps: {
	        "innerHTML": _vm._s(item.title.rendered)
	      }
	    }), _vm._v(" "), _c('p', {
	      class: _vm.$style.description
	    }, [_vm._v(_vm._s(item.acf.description))])])
	  }), 0), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app"
	  }, [_c('router-view'), _vm._v(" "), _c('footer', {
	    staticClass: "wrap",
	    class: _vm.$style.footer
	  }, [_c('p', [_vm._v("© " + _vm._s(_vm.getYear) + " Rick Blything unless otherwise stated.")]), _vm._v(" "), _vm._m(0)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Site by "), _c('a', {
	    attrs: {
	      "href": "https://afew.london"
	    }
	  }, [_vm._v("AFEW")])])
	}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    class: _vm.$style.loader,
	    attrs: {
	      "width": "135",
	      "height": "140",
	      "viewBox": "0 0 135 140",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "#fff"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "y": "10",
	      "width": "15",
	      "height": "120",
	      "rx": "6"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeName": "height",
	      "begin": "0.25s",
	      "dur": "0.5s",
	      "values": "120;110;100;90;80;70;60;50;40;140;120",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  }), _vm._v(" "), _c('animate', {
	    attrs: {
	      "attributeName": "y",
	      "begin": "0.25s",
	      "dur": "0.5s",
	      "values": "10;15;20;25;30;35;40;45;50;0;10",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  })]), _vm._v(" "), _c('rect', {
	    attrs: {
	      "x": "30",
	      "y": "10",
	      "width": "15",
	      "height": "120",
	      "rx": "6"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeName": "height",
	      "begin": "0.125s",
	      "dur": "0.5s",
	      "values": "120;110;100;90;80;70;60;50;40;140;120",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  }), _vm._v(" "), _c('animate', {
	    attrs: {
	      "attributeName": "y",
	      "begin": "0.125s",
	      "dur": "0.5s",
	      "values": "10;15;20;25;30;35;40;45;50;0;10",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  })]), _vm._v(" "), _c('rect', {
	    attrs: {
	      "x": "60",
	      "width": "15",
	      "height": "140",
	      "rx": "6"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeName": "height",
	      "begin": "0s",
	      "dur": "0.5s",
	      "values": "120;110;100;90;80;70;60;50;40;140;120",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  }), _vm._v(" "), _c('animate', {
	    attrs: {
	      "attributeName": "y",
	      "begin": "0s",
	      "dur": "0.5s",
	      "values": "10;15;20;25;30;35;40;45;50;0;10",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  })]), _vm._v(" "), _c('rect', {
	    attrs: {
	      "x": "90",
	      "y": "10",
	      "width": "15",
	      "height": "120",
	      "rx": "6"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeName": "height",
	      "begin": "0.125s",
	      "dur": "0.5s",
	      "values": "120;110;100;90;80;70;60;50;40;140;120",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  }), _vm._v(" "), _c('animate', {
	    attrs: {
	      "attributeName": "y",
	      "begin": "0.125s",
	      "dur": "0.5s",
	      "values": "10;15;20;25;30;35;40;45;50;0;10",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  })]), _vm._v(" "), _c('rect', {
	    attrs: {
	      "x": "120",
	      "y": "10",
	      "width": "15",
	      "height": "120",
	      "rx": "6"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeName": "height",
	      "begin": "0.25s",
	      "dur": "0.5s",
	      "values": "120;110;100;90;80;70;60;50;40;140;120",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  }), _vm._v(" "), _c('animate', {
	    attrs: {
	      "attributeName": "y",
	      "begin": "0.25s",
	      "dur": "0.5s",
	      "values": "10;15;20;25;30;35;40;45;50;0;10",
	      "calcMode": "linear",
	      "repeatCount": "indefinite"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', [(_vm.item) ? _c('article', {
	    staticClass: "wrap",
	    class: _vm.$style.post
	  }, [_c('header', {
	    class: _vm.$style.header
	  }, [_c('h1', {
	    class: _vm.$style.title,
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title.rendered)
	    }
	  }), _vm._v(" "), _c('p', {
	    class: _vm.$style.meta,
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.description)
	    }
	  })]), _vm._v(" "), _c('div', {
	    class: _vm.$style.body
	  }, [(_vm.item.acf.vimeo_url) ? _c('figure', [_c('iframe', {
	    attrs: {
	      "src": _vm.getVimeoUrl,
	      "width": "640",
	      "height": "360",
	      "frameborder": "0",
	      "webkitallowfullscreen": "",
	      "mozallowfullscreen": "",
	      "allowfullscreen": ""
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.content.rendered)
	    }
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('site-header', [_c('h1', [_vm._v("About me")])]), _vm._v(" "), (this.page.content) ? _c('main', {
	    ref: "pageContent",
	    staticClass: "wrap",
	    class: _vm.$style.about,
	    domProps: {
	      "innerHTML": _vm._s(this.page.content.rendered)
	    }
	  }) : _vm._e(), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.65c0ed28526afa52c21b.js